<template>
    <div class="row">
        <template v-for="(a,i) in approveStatuses">
            <div :class="['col-12',{'mt-50':i != 0}]">
                <div class="border rounded overflow-hidden">
                    <div :class="['px-1 py-50 font-weight-bolder d-flex justify-content-between align-items-center',a.CycleIndex != maxCycle ? 'text-muted':'bg-light-success']" v-b-toggle="`ci-${i}`">
                        <span>{{(i + 1)}}. Tur</span>
                        <feather-icon icon="ChevronDownIcon"></feather-icon>
                    </div>
                    <b-collapse :visible="a.CycleIndex == maxCycle" :id="`ci-${i}`">
                        <div class="border-top">
                            <div class="row p-50">
                                <template v-for="(g,ii) in a.LevelsGrouped">
                                    <div :class="['col-12',{'mt-1':ii != 0}]" :key="ii">
                                        <div class="bg-light-info mb-1 px-1 py-50 rounded">
                                            {{ g.Level }}. Sıra
                                        </div>
                                        <app-timeline>
                                            <app-timeline-item :description="item.Description" v-for="(item,index) in ($safe(g,'Levels') || [])" :key="index" :time="item.DateStr" :title="item.ApproverUserFullName" :subtitle="getSubTitle($safe(item,'ApprovalStatusType'))" variant="info"/>
                                        </app-timeline>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>

        </template>
    </div>
</template>

<script>
import AppTimeline from '@/@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@/@core/components/app-timeline/AppTimelineItem.vue'
import { VBToggle, BCollapse } from 'bootstrap-vue'

export default {
    components:{
        AppTimeline,
        AppTimelineItem,
        BCollapse
    },
    directives:{
        'b-toggle':VBToggle
    },
    props:{
        approveStatuses:Array
    },
    methods:{
        getSubTitle(type){
            if(type == 0) return 'Onay Bekliyor'
            else if(type == 1) return 'Onaylandı'
            else if(type == 2) return 'Reddedildi'
            else return 'Bilinmiyor'
        }
    },
    computed:{
        maxCycle(){
            return Math.max(...(this.approveStatuses || []).map(s => s.CycleIndex),0)
        }
    }
}
</script>